<template>
  <el-row
    :class="b()"
    type="flex"
    align="middle"
  >
    <el-row
      :class="b('project')"
      type="flex"
      align="middle"
    >
      <span
        :class="b('p-icon')"
        :style="{ background: currentProjectBgColor }"
      >
        {{ currentProjectFirstChar }}
      </span>
      <span
        v-overflow-tooltip="currentProjectName"
        :class="['text-ellipsis', b('p-name')]"
      >
        {{ currentProjectName }}
      </span>
      <div
        v-if="isProjectInnerCollaborator"
        :class="b('inner-collaborator-project')"
      >
        {{ $t('saas.innerCollaboratorProject.label') }}
      </div>
    </el-row>
    <MoreBox
      :list="menus"
      id-key="name"
      :class="b('navs')"
    >
      <template #default="{ item }">
        <div
          :class="[b('nav'), {'is-active': item.active}]"
          @click="jump(item)"
        >
          <el-tooltip
            placement="bottom"
            :open-delay="500"
            popper-class="hot-key-tip-popper"
            :disabled="!item.toolTip"
          >
            <div slot="content">
              <span class="hot-key-tip-desc">{{ item.toolTip || item.meta.title }}</span>
              <template v-for="(key, index) in item.hotKey">
                <template>
                  <em
                    v-if="item.hotKey.length > 1 && index !== 0"
                    :key="index"
                    :class="['zkicon icontianjia_xiao', 'hot-key-tip-add']"
                  />
                  <el-tag
                    :key="key + index"
                    class="hot-key-tip-tag"
                  >
                    <span>{{ key }}</span>
                  </el-tag>
                </template>
              </template>
            </div>
            <el-new-badge v-bind="item.segment || {segments: false}">
              <el-row
                v-ripple="{
                  center: false,
                  circle: false
                }"
                type="flex"
                align="middle"
                :class="b('nav-name',item.name)"
              >
                {{ item.meta.title }}
              </el-row>
            </el-new-badge>
          </el-tooltip>
        </div>
      </template>
      <template #more="{ hideList }">
        <el-popover
          :visible-arrow="false"
          :popper-class="b('more-popper')"
        >
          <template #reference>
            <div :class="[b('nav', 'more'), {'is-active': isMoreActive(hideList)}]">
              {{ $t('navbar.more_results') }}
            </div>
          </template>
          <DropdownItem
            v-for="item of hideList"
            :key="item.name"
            :title="item.meta.title"
            :active="item.active"
            @click="jump(item)"
          >
          </DropdownItem>
        </el-popover>
      </template>
    </MoreBox>
    <el-row
      :class="b('actions')"
      type="flex"
      align="middle"
    >
      <el-row
        :class="[b('action-btn'), {'is-active': isSmartAssistantActive}, 'top-nav-automation']"
        type="flex"
        align="middle"
        justify="center"
        @click.native="toSmartAssistant"
      >
        <em class="zkicon iconmanagerule" />
        <span>{{ $t('navbar.manage_rule') }}</span>
      </el-row>

      <el-row
        v-if="validMembers.length === 1 && checkAccessPermission(permission.inviteMember)"
        :class="[b('action-btn'), {'is-active': showInviteMember}]"
        type="flex"
        align="middle"
        justify="center"
        @click.native="showInviteMember = true"
      >
        <el-tooltip :content="$t('project.Invite_Members')">
          <div>
            <em class="zkicon iconyaoqing" />
            <span>{{ $t('button.invite') }}</span>
          </div>
        </el-tooltip>
      </el-row>
      <el-tooltip
        v-if="validMembers.length > 1"
        :class="[b('action-btn','member'), { 'cursor-pointer': checkAccessPermission(permission.projectMemberPage) }]"
        :popper-class="b('member-tip-popper')"
        :content="allMemberName"
        :open-delay="500"
      >
        <el-row type="flex">
          <el-row
            type="flex"
            align="middle"
            :class="b('members-avatar')"
            @click.native="toMember"
          >
            <el-avatar
              v-if="showMembers.length <= 1"
              class="isIconyonghu"
              :size="25"
              icon="zkicon iconyonghu"
            />
            <el-avatar
              v-for="(user) of showMembers"
              :key="user.currentProjectMembers"
              :src="user.head"
              :size="25"
            />
          </el-row>
        </el-row>
      </el-tooltip>
    </el-row>

    <ProjectInviteMember
      v-if="showInviteMember"
      :default-tab="projectInviteMemberDefaultTab"
      :is-project-setting-page="isProjectSettingPage"
      @close="inviteMemberClose"
    />
  </el-row>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import theme from '@zk/theme/lib/variables.scss';
import MoreBox from 'common-module/src/components/more-box/MoreBox';
import ProjectInviteMember from '@/components/InviteMemer/ProjectInviteMember';
import * as permission from 'common-module/src/config/permission';

export default {
  name: 'TopNav',
  components: {
    ProjectInviteMember,
    MoreBox,
    DropdownItem: () => import('common-module/src/components/DropdownItem')
  },
  bemNS: theme.bemNS,
  inject: ['appLayout'],
  props: {
    microAppName: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      showInviteMember: false,
      projectInviteMemberDefaultTab: 'inviteOrgMember', //进入项目邀请弹窗默认的tab
      isProjectSettingPage: false,
      permission
    };
  },
  computed: {
    ...mapState('app', ['currentProjectMembers', 'isGuiding', 'issueImportFrom']),
    ...mapGetters('app', ['currentProjectFirstChar', 'currentProjectName', 'currentProjectBgColor', 'checkMenuVisible']),
    ...mapGetters('user', ['checkRole', 'checkAccessPermission', 'isProjectInnerCollaborator']),
    ...mapGetters('features', ['isCurrentProjectSwitch', 'isSwitch']),
    isOpenGantt() {
      return this.$store.getters['features/isSwitch']('user:gantt_switch');
    },
    validMembers(){
      return this.currentProjectMembers.filter(i => i.enabled !== null);
    },
    showMembers() {
      return this.validMembers.slice(0, 3).reverse();
    },
    allMemberName() {
      return `${this.validMembers?.length} members`;
    },
    /**
     * 是否开启迭代功能
     * @returns {*}
     */
    isSprintFeatures() {
      return this.isCurrentProjectSwitch('module_sprint_switch');
    },
    menus() {
      return [{
        name: 'kanban',
        path: '/kanban/list',
        active: this.microAppName === 'kanban',
        hotKey: ['G', 'S'],
        toolTip: this.isSprintFeatures ? this.$t('navbar.hotkeys.enterFollowUp') : this.$t('navbar.hotkeys.enterKanban'),
        meta: {
          title: this.isSprintFeatures ? this.$t('route.sprint_track') : this.$t('route.Kanban')
        },
        hidden: !this.checkMenuVisible('kanban')
      }, {
        name: 'backlog',
        path: '/backlog/list',
        active: this.microAppName === 'backlog',
        hotKey: ['G', 'B'],
        toolTip: this.$t('navbar.hotkeys.enterBackLog'),
        meta: {
          title: this.$t('route.Backlog'),
          ...permission.backlogPage
        },
        hidden: [!this.checkMenuVisible('backlog')].some(i => i)
      }, {
        name: 'issue-airtable',
        path: '/work/table',
        active: this.microAppName === 'work' && this.$route.path.startsWith('/work/table') || (this.appLayout.importPageFromAirTable && this.appLayout.isImportPage),
        meta: {
          title: this.isKeepWorkList ? this.$t('route.IssuesAirtable') : this.$t('route.Issues')
        },
        hotKey: this.isWorkListToAirtable && !this.isKeepWorkList ? ['G', 'W'] : [],
        toolTip: this.isWorkListToAirtable && !this.isKeepWorkList ? this.$t('navbar.hotkeys.enterIssuePage') : null,
        hidden: !this.isWorkListToAirtable || !this.checkMenuVisible('work_list')
      }, {
        name: 'epic-list',
        path: '/epic/list',
        active: this.microAppName === 'epic' && this.$route.path.startsWith('/epic/list'),
        hotKey: ['G', 'E'],
        toolTip: this.$t('navbar.hotkeys.enterEpicPage'),
        meta: {
          title: this.$t('route.Epic'),
          ...permission.epicPage
        },
        hidden: [!this.checkMenuVisible('epic'), this.isOpenGantt].some(i => i)
      }, {
        name: 'gantt',
        path: '/project/gantt',
        active: this.isProjectGantt,
        hotKey: ['G', 'E'],
        toolTip: this.$t('navbar.hotkeys.enterGanttPage'),
        meta: {
          title: this.$t('route.gantt'),
          ...permission.ganttPage
        }
      }, {
        name: 'cicd',
        path: '/project/cicd',
        active: this.appLayout.isProjectJenkinsActive,
        meta: {
          title: this.$t('route.Jenkins'),
          ...permission.cicdPage
        },
        hidden: !this.checkMenuVisible('cicd')
      }, {
        name: 'project-overview',
        path: '/project/overview',
        active: this.appLayout.isProjectOverviewActive,
        meta: {
          title: this.$t('route.Overview'),
          ...permission.projectOverview
        },
        hidden: [!this.checkMenuVisible('overview')].some(i => i)
      }, {
        name: 'project-worktype',
        path: '/project/worktype',
        active: this.isSettingActive,
        meta: {
          title: this.$t('project.topNav.setting'),
          ...permission.projectSetting
        },
        handler: () => {
          const permissionOpenConfig = [{
            meta: permission.projectIssueTypePage,
            handler: () => {
              this.$router.push('/project/worktype');
            }
          }, {
            meta: permission.projectMemberPage,
            handler: () => {
              this.$router.push('/project/member');
            }
          }, {
            meta: permission.projectMemberGroupPage,
            handler: () => {
              this.$router.push('/project/department');
            }
          }, {
            meta: permission.projectWorkflowPage,
            handler: () => {
              this.$router.push('/project/workflow');
            }
          }, {
            meta: permission.projectFeaturesPage,
            handler: () => {
              this.$router.push('/project/features');
            }
          }, {
            meta: permission.projectWebhookPage,
            handler: () => {
              this.$router.push('/project/webhook');
            }
          }, {
            meta: permission.projectLogsPage,
            handler: () => {
              this.$router.push('/project/log');
            }
          }, {
            meta: permission.projectTagsPage,
            handler: () => {
              this.$router.push('/project/tags');
            }
          }, {
            meta: permission.projectPermission,
            handler: () => {
              this.$router.push('/project/permission');
            }
          }, {
            meta: permission.automationPage,
            handler: () => {
              this.$router.push('/project/automation');
            }
          }];
          for (const config of permissionOpenConfig) {
            if (this.checkAccessPermission(config.meta)) {
              config.handler();
              return;
            }
          }
        }
      }
      ].filter(item => item.hidden !== true && this.checkAccessPermission(item.meta));
    },
    isSettingActive() {
      return this.microAppName === 'project' && !this.appLayout.isProjectJenkinsActive && !this.appLayout.isProjectOverviewActive && !this.isProjectGantt;
    },
    isProjectGantt() {
      return this.microAppName === 'project' && this.$route.path.startsWith('/project/gantt');
    },
    isSmartAssistantActive() {
      return this.microAppName === 'project' && this.$route.path.startsWith('/project/automation');
    },
    isWorkListToAirtable() {
      return this.appLayout.isWorkListToAirtable;
    },
    isKeepWorkList() {
      return this.appLayout.isKeepWorkList;
    }
  },
  mounted() {
    this.refreshJenkinsOpenStatus();
    this.refreshCIStatus(['gitLab', 'foxLab']);
    setTimeout(() => this.loadProjectMember(), 3000);

    this.eventBus.$on('project-show-invite-member', this.handleShowInviteMember);
    this.eventBus.$on('project:member-change', this.handleMemberChange);

  },
  beforeDestroy(){
    this.eventBus.$off('project-show-invite-member', this.handleShowInviteMember);
    this.eventBus.$off('project:member-change', this.handleMemberChange);
  },
  methods: {
    ...mapActions('app', ['loadProjectMember']),
    ...mapActions('features', ['refreshJenkinsOpenStatus', 'refreshCIStatus']),
    jump(item){
      if (item.handler) {
        item.handler();
        return;
      }
      const routePath = item.path;
      this.$router.push(routePath);
    },
    handleShowInviteMember(isProjectSettingPage, tab){
      this.projectInviteMemberDefaultTab = tab || 'inviteOrgMember';
      this.showInviteMember = true;
      this.isProjectSettingPage = !!isProjectSettingPage;
    },
    inviteMemberClose() {
      this.showInviteMember = false;
      this.isProjectSettingPage = false;
    },
    handleMemberChange(){
      this.loadProjectMember({ force: true });
    },
    isMoreActive(hideList) {
      return hideList.some(n => n.active);
    },
    toMember() {
      if (!this.checkAccessPermission(permission.projectMemberPage)) {
        return;
      }
      this.$router.push('/project/member');
    },
    toSmartAssistant() {
      this.$router.push({
        path: '/project/automation',
        query: {
          shortcut: 'shortcut'
        }
      });
      this.$track.send('LIA_List', {
        source: '快速入口',
        role: this.$store.getters.projectRoles?.map(i => `${i.projectRole ? '项目' : '组织'}-${i.roleName}`)
      }, true);
    }
  }
};
</script>

<style lang="scss">
.isOverseasCollapse .zk-top-nav{
  padding-left: 30px;
}
.driver-fix-index .RightContent_wrapperEn_1m8cE{
  position: absolute;
}
@include b(top-nav) {
  height: 100%;
  min-width: 680px;
  @include e(project) {
    max-width: 400px;
    flex-shrink: 0;
    margin-right: var(--m-large);
    font-weight: bold;
  }
  @include e(p-icon) {
    width: 16px;
    height: 16px;
    line-height: 16px;
    text-align: center;
    border-radius: 2px;
    margin-right: var(--m-small);
    font-size: var(--size-font-9);
    color: var(--main-bg-color);
    flex-shrink: 0;
  }
  @include e(p-name) {
    flex: 1;
    color: var(--font-color-1);
  }
  @include e(inner-collaborator-project) {
    height: 20px;
    display: inline-block;
    padding: 0 4px;
    color: var(--primary-color);
    border-radius: 4px;
    background-color: rgba(60, 62, 192, 0.06);;
    font-size: 12px;
    white-space: nowrap;
    line-height: 20px;
    text-align: center;
    font-weight: 400!important;
    margin-left: var(--m-small);
  }
  @include e(navs) {
    display: flex;
    align-items: center;
    flex: 1;
    height: 100%;
    overflow: hidden;
    white-space: nowrap;
    margin-right: var(--m-large);
    .zk-more-item {
      height: 100%;
    }
  }
  @include e(nav) {
    padding: 0 12px;
    display: flex;
    align-items: center;
    position: relative;
    height: 100%;
    cursor: pointer;
    color: var(--font-color-2);
    .el-row {
      padding: 0 8px;
      height: 30px;
      border-radius: var(--radius-mini);
    }
    &:hover {
      .el-row {
        background: var(--gray-transparent-hover);
      }
    }
    .zk-symbol-icon {
      position: absolute;
      right: 8px;
      top: 2px;
    }
    @include m(more) {
      padding: 0 20px;
    }
    @include when(active) {
      color: var(--font-color-1);
      font-weight: var(--weight-font-Semiblod);;
      &:after {
        content: "";
        position: absolute;
        bottom: 1px;
        left: 0;
        width: calc(100% - 40px);
        height: 3px;
        background: var(--primary-color);
        border-radius: var(--radius-mini);
        margin: 0 20px;
      }
    }
  }
  @include e(actions) {
    // flex-shrink: 0;
    .el-divider--vertical {
      margin: 0 var(--m-default);
    }
  }
  @include e(action-btn) {
    // width: 30px;
    height: 30px;
    padding: 6px 12px;
    cursor: pointer;
    border-radius: var(--radius-default);
    & + & {
      margin-left: var(--m-small);
    }
    &:hover {
      background: var(--gray-transparent-hover);
    }
    span {
      color: var(--font-color-2);
      font-weight: var(--weight-font-Semiblod);
    }
    @include when(active) {
      background: var(--brand-transparent-active-2);
      @include iconColor(var(--primary-color));
    }
    @include icon {
      font-size: 16px;
      line-height: 1;
      color: var(--purpleGray-7);
      margin-right: 8px;
    }
   @include m(member) {
      padding: 2px 6px 3px 16px;
   }
  }
  @include e(tag-key) {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    width: 27px;
    height: 20px !important;
    background-color: #5b5c6f !important;
    border: none !important;
    color: var(--font-color-5) !important;
  }
  @include e(members) {
    margin-right: var(--m-default);
  }
  @include e(member-tip-popper) {
    max-width: 500px !important;
    max-height: 70%;
    overflow-y: auto;
  }
  @include e(members-avatar) {
    flex-direction: row-reverse;
    // padding: 3px 0 6px;
    .el-avatar {
      border: 1px solid var(--main-bg-color);
      margin-left: -10px;
      position: relative;
      &.isIconyonghu{
        background: transparent;
      }
    }
    .iconyonghu{
      font-size: 25px;
      color: #eee;
    }
  }
  @include e(more-member) {
    margin-left: -6px;
    height: 24px;
    border-radius: 10px;
    padding: 0 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #F4F4F6;
    color: #707070;
    font-size: 10px;
    line-height: 1;
    > span {
      transform: scale(0.9);
      line-height: 1;
    }
  }
  @include e(more-popper) {
    padding: 8px;
    min-width: 50px;
    .zk-dropdown-item {
      margin-top: 2px;;
      &:first-child {
        margin-top: 0;
      }
    }
    .zk-dropdown-item.is-active {
      color: var(--primary-color);
    }
    .zk-dropdown-item__title {
      margin: 0;
    }
  }
}
</style>
